<template>
  <v-menu v-model="menuOpen" :close-on-content-click="false" transition="scale-transition"
          offset-y max-width="300" max-height="300" :nudge-top="outlined?24:16">
    <template v-slot:activator="{on}">
      <v-text-field :label="label" :class="caption ? 'text-caption' : 'text-body-2'" readonly v-on="on" v-model="name" dense :outlined="outlined"
                    append-icon="mdi-menu-down" @click:append="menuOpen=true" :disabled="disabled" :hide-details="hideDetails"
                    :hint="hint" :persistent-hint="persistentHint"
                    :rules="[valid]" :autofocus="autofocus"/>
    </template>

    <v-list dense>
      <v-list-item-group v-model="selectFirst" color="primary" mandatory>
        <div v-if="actionEvent" class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="$emit(actionEvent)">
          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>{{actionText}}
        </div>

        <template v-for="menu in menuData">
          <v-menu v-if="menu.menu" :key="menu.id" offset-x nudge-left="10" max-height="300">
            <template v-slot:activator="{on:submenu}">
              <v-list-item :value="menu.id" v-on="submenu" @click="selectSecond=null;selectThird=null">
                <v-list-item-title :class="titleClass(menu)">{{menu.name}}</v-list-item-title>
                <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
              </v-list-item>
            </template>

            <v-list dense>
              <v-list-item-group v-model="selectSecond" color="primary">

                <div v-if="menu.actionEvent" class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="$emit(menu.actionEvent)">
                  <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>{{menu.actionText}}
                </div>

                <v-list-item>
                  <v-text-field @click.stop="" class="text-caption" v-model="search2" dense hide-details placeholder="Search" clearable/>
                </v-list-item>

<!--
                <template v-for="menu2 in menu.menu">
-->
                <template v-for="menu2 in filter(menu.menu, search2)">
                  <v-menu v-if="menu2.menu" :key="menu2.id" offset-x nudge-left="10" max-height="300">
                    <template v-slot:activator="{on:submenu2}">
                      <v-list-item :value="menu2.id" v-on="submenu2" @click="selectThird=null">
                        <v-list-item-title :class="titleClass(menu2)">{{menu2.name}}</v-list-item-title>
                        <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                      </v-list-item>
                    </template>

                    <v-list dense>
                      <v-list-item-group v-model="selectThird" color="primary">

                        <div v-if="menu2.actionEvent" class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="$emit(menu2.actionEvent)">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>{{menu2.actionText}}
                        </div>

                        <v-list-item>
                          <v-text-field @click.stop="" class="text-caption" v-model="search3" dense hide-details placeholder="Search" clearable/>
                        </v-list-item>

                        <v-list-item v-for="menu3 in filter(menu2.menu, search3)" :value="menu3.id" :key="menu3.id" @click="close(menu.id, menu2.id, menu3.id)" :disabled="menu3.disabled">
                          <v-list-item-content>
                            <v-list-item-title :class="titleClass(menu3)">{{menu3.name}}</v-list-item-title>
                            <v-list-item-subtitle v-if="menu3.subTitle" class="text-caption">
                              {{menu3.subTitle}}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>

                  </v-menu>
                  <v-divider v-else-if="menu2.divider"/>
                  <v-list-item v-else :key="menu2.id" :value="menu2.id" @click="close(menu.id, menu2.id)" :disabled="menu2.disabled">
                    <v-list-item-content>
                      <v-list-item-title :class="titleClass(menu2)">{{menu2.name}}</v-list-item-title>
                      <v-list-item-subtitle v-if="menu2.subTitle" class="text-caption">
                        {{menu2.subTitle}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>

          </v-menu>
          <v-divider v-else-if="menu.divider"/>
          <v-list-item v-else :key="menu.id" :value="menu.id" @click="close(menu.id, '', '')" :disabled="menu.disabled">
            <v-list-item-title :class="titleClass(menu)">{{menu.name}}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-menu>

<!--
                    :disabled="disabled" :outlined="outlined" :dense="dense"
                    :persistent-hint="persistentHint" :hint="hint"
                    :hide-details="hideDetails"
  -->

</template>

<script>
export default {
  name: 'MultiLevelSelect',
  props: {
		menuData: {type:Array,required:true},
		label: {type:String,required:false},
		first: {type:String,required:false},
		second: {type:String,required:false},
    disabled: {type:Boolean,required:false,default:false},
    hideDetails: {type:Boolean,required:false,default:false},
    outlined: {type:Boolean,required:false,default:false},
    persistentHint: {type:Boolean,required:false,default:false},
		hint: {type:String,required:false},
    actionEvent: {type:String,required:false},
    actionText: {type:String,required:false},
    noValidation: {type:Boolean,required:false,default:false},
    autofocus: {type:Boolean,required:false,default:false},
    caption: {type:Boolean,required:false,default:false}
  },
  data() {
    return {
      menuOpen: false,
      selectFirst: this.first,
      selectSecond: this.second,
      selectThird: this.second,
      name: '',
      search2: '',
      search3: ''
    }
  },
  watch: {
    first() {
      this.selectFirst = this.first;
      this.setName();
    },
    second() {
      this.selectSecond = this.second;
      this.setName();
    },
    menuData() {
      this.setName();
    }
  },
  created() {
    this.setName();
  },
  methods: {
    filter(menu, search) {
      if (!search)
        return menu;
      const searchTerm = search.toLowerCase();
      return menu.filter(m => !m.divider &&
                               (m.name.toLowerCase().includes(searchTerm) ||
                                m.subTitle?.toLowerCase().includes(searchTerm)));
    },
    setName() {
      this.name = '';
      const one = this.menuData.find(m => m.id === this.first && !m.divider);
      if (one) {
        this.name = one.name;
        let two = one?.menu?.find(m => m.id === this.second);
        if (!two && this.second && one?.menu) {
          for (const menu of one.menu) {
            two = menu.menu?.find(m => m.id === this.second);
            if (two) {
              break;
            }
          }
        }
        if (two)
          if (this.first)
            this.name = `${this.name}: ${two.name}`;
          else
            this.name = two.name;
      }
      else {
        let m;
        for (const item of this.menuData) {
          m = item.menu?.find(m => m.id === this.second);
          if (m) {
            break;
          }
        }
        if (m)
          this.name = m.name;
      }

    },
    valid() {
      if (this.disabled || this.noValidation)
        return true;
      const first = this.menuData.find(m => m.id === this.selectFirst);
      const second = first?.menu?.find(m => m.id === this.selectSecond);
      return (!!this.selectFirst && !first?.menu) || (!!this.selectSecond && !second?.menu) || !!this.selectThird || 'Required';
    },
    titleClass(menu) {
      return menu.level ? `ml-${menu.level*2}` : '';
    },
    close(first, second, third) {
      this.menuOpen = false;
      this.$emit('update:first', first);
      this.$emit('update:second', second);
      if (third)
        this.$emit('update:second', third);
      this.$emit('change');
    }
  }
}
</script>
